import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Labeled extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    displayAlways: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    label: null,
    displayAlways: false,
    className: undefined,
    children: null,
  };

  render() {
    const { label, displayAlways, className, children } = this.props;

    if ((children === null || typeof children === 'undefined') && !displayAlways) {
      return null;
    }

    const wrapperClasses = clx('wrapper', className);

    return (
      <div className={wrapperClasses}>
        <span className={styles['label']}>{label}</span>
        <span className={styles['text']}>{children}</span>
      </div>
    );
  }
}
